import { z } from 'zod';
import { numberParameter } from './shared.js';

// SDERIVF: API 2026 Update 0.1 p91; Macro-PLUS pp95–96.
const surfaceDerivativesSettings = z.strictObject({
  surface: z.number().int().nonnegative().max(2147483647).describe('Native surface index; 0 is the object. CODE V validates existence.'),
  zoom: z.number().int().positive().max(2147483647).default(1).describe('Native 1-based zoom position. The default 1 is the first position, which every lens has; a lens without ZOO has only that one (PromptingGuide p74; ZoomSystems.17.02, ZOO range 1 to 99).'),
  points: z.array(z.strictObject({ x: z.number(), y: z.number() })).min(1)
    .describe('Explicit X/Y coordinates in system length units, retained in input order. No sampling grid is generated.'),
});
export default {
  label: 'Surface Derivatives', group: 'system',
  description: 'Surface sag and its first and second derivatives at the points you enter.',
  settingsSchema: surfaceDerivativesSettings,
  parameters: [
    numberParameter('surface', 'Surface', { integer: true, choices: 'surface', prominent: true }),
    numberParameter('zoom', 'Zoom position', { integer: true, hidden: true }),
    { key: 'points', label: 'Surface coordinates', kind: 'rows', prominent: true, columns: [
      numberParameter('x', 'X', { unit: 'system length' }),
      numberParameter('y', 'Y', { unit: 'system length' }),
    ] },
  ],
  coverage: 'One surface per run, including any interferogram deformation on the surface. Sag is in lens units, slopes are dimensionless and second derivatives are in reciprocal lens units. If CODE V reports an error or warning, no values are shown.',
} as const;
